export interface AdamsError {
    response?: {
        data?: {
            error?: string;
            reason?: string;
            result: string;
        };
    };
    message: string;
}

export const getErrorMessage: (error: AdamsError | null) => string | undefined = (error) => {
    if (!error) return undefined;
    if (error.response?.data?.result === 'Error') {
        return error.response.data.reason ?? error.message;
    }
    return error.message;
};
